import {useRouter} from 'next/router';
import {requestContext} from '../../requestContext';
import {useGetScrollInfo} from './useGetScrollInfo';

export function useGetTopMenuHidden() {
  const router = useRouter();
  const shouldPageHideTopMenu =
    router.pathname === '/' ||
    router.pathname.startsWith('/menu') ||
    router.pathname.startsWith('/day-of-week');
  const {isMobile} = requestContext.requestInfo.display;
  const isTopMenuHiddenEnabled = isMobile && shouldPageHideTopMenu;
  const {direction, isScrolledEnough} = useGetScrollInfo(
    isTopMenuHiddenEnabled
  );

  return {
    shouldPageHideTopMenu,
    isTopMenuHidden:
      isTopMenuHiddenEnabled && direction === 'DOWN' && isScrolledEnough,
  };
}
